import customLogoUrl from '@pages/diver/assets/4rabet/logo.svg';
import customBgUrl from '@pages/diver/assets/4rabet/gameWindow.png';
import historySubmarineUrl from '@pages/diver/assets/4rabet/history.png';
import rocket_anim_0 from '@pages/diver/assets/4rabet/4rabet-anim/Comp 2_00000.png';
import rocket_anim_1 from '@pages/diver/assets/4rabet/4rabet-anim/Comp 2_00001.png';
import rocket_anim_2 from '@pages/diver/assets/4rabet/4rabet-anim/Comp 2_00002.png';
import rocket_anim_3 from '@pages/diver/assets/4rabet/4rabet-anim/Comp 2_00003.png';
import rocket_anim_4 from '@pages/diver/assets/4rabet/4rabet-anim/Comp 2_00004.png';
import rocket_anim_5 from '@pages/diver/assets/4rabet/4rabet-anim/Comp 2_00005.png';
import rocket_anim_6 from '@pages/diver/assets/4rabet/4rabet-anim/Comp 2_00006.png';
import rocket_anim_7 from '@pages/diver/assets/4rabet/4rabet-anim/Comp 2_00007.png';
import rocket_anim_8 from '@pages/diver/assets/4rabet/4rabet-anim/Comp 2_00008.png';
import rocket_anim_9 from '@pages/diver/assets/4rabet/4rabet-anim/Comp 2_00009.png';
import rocket_anim_10 from '@pages/diver/assets/4rabet/4rabet-anim/Comp 2_00010.png';
import rocket_anim_11 from '@pages/diver/assets/4rabet/4rabet-anim/Comp 2_00011.png';
import rocket_anim_12 from '@pages/diver/assets/4rabet/4rabet-anim/Comp 2_00012.png';
import rocket_anim_13 from '@pages/diver/assets/4rabet/4rabet-anim/Comp 2_00013.png';
import rocket_anim_14 from '@pages/diver/assets/4rabet/4rabet-anim/Comp 2_00014.png';
import rocket_anim_15 from '@pages/diver/assets/4rabet/4rabet-anim/Comp 2_00015.png';
import rocket_anim_16 from '@pages/diver/assets/4rabet/4rabet-anim/Comp 2_00016.png';
import rocket_anim_17 from '@pages/diver/assets/4rabet/4rabet-anim/Comp 2_00017.png';
import rocket_anim_18 from '@pages/diver/assets/4rabet/4rabet-anim/Comp 2_00018.png';
import rocket_anim_19 from '@pages/diver/assets/4rabet/4rabet-anim/Comp 2_00019.png';
import rocket_anim_20 from '@pages/diver/assets/4rabet/4rabet-anim/Comp 2_00020.png';
import rocket_anim_21 from '@pages/diver/assets/4rabet/4rabet-anim/Comp 2_00021.png';
import rocket_anim_22 from '@pages/diver/assets/4rabet/4rabet-anim/Comp 2_00022.png';
import rocket_anim_23 from '@pages/diver/assets/4rabet/4rabet-anim/Comp 2_00023.png';
import rocket_anim_24 from '@pages/diver/assets/4rabet/4rabet-anim/Comp 2_00024.png';
import rocket_anim_25 from '@pages/diver/assets/4rabet/4rabet-anim/Comp 2_00025.png';
import rocket_anim_26 from '@pages/diver/assets/4rabet/4rabet-anim/Comp 2_00026.png';
import rocket_anim_27 from '@pages/diver/assets/4rabet/4rabet-anim/Comp 2_00027.png';
import rocket_anim_28 from '@pages/diver/assets/4rabet/4rabet-anim/Comp 2_00028.png';
import rocket_anim_29 from '@pages/diver/assets/4rabet/4rabet-anim/Comp 2_00029.png';
import rocket_anim_30 from '@pages/diver/assets/4rabet/4rabet-anim/Comp 2_00030.png';
import rocket_anim_31 from '@pages/diver/assets/4rabet/4rabet-anim/Comp 2_00031.png';
import rocket_anim_32 from '@pages/diver/assets/4rabet/4rabet-anim/Comp 2_00032.png';
import rocket_anim_33 from '@pages/diver/assets/4rabet/4rabet-anim/Comp 2_00033.png';
import rocket_anim_34 from '@pages/diver/assets/4rabet/4rabet-anim/Comp 2_00034.png';
import rocket_anim_35 from '@pages/diver/assets/4rabet/4rabet-anim/Comp 2_00035.png';
import rocket_anim_36 from '@pages/diver/assets/4rabet/4rabet-anim/Comp 2_00036.png';
import rocket_anim_37 from '@pages/diver/assets/4rabet/4rabet-anim/Comp 2_00037.png';
import rocket_anim_38 from '@pages/diver/assets/4rabet/4rabet-anim/Comp 2_00038.png';
import rocket_anim_39 from '@pages/diver/assets/4rabet/4rabet-anim/Comp 2_00039.png';
import rocket_anim_40 from '@pages/diver/assets/4rabet/4rabet-anim/Comp 2_00040.png';
import rocket_anim_41 from '@pages/diver/assets/4rabet/4rabet-anim/Comp 2_00041.png';
import rocket_anim_42 from '@pages/diver/assets/4rabet/4rabet-anim/Comp 2_00042.png';
import rocket_anim_43 from '@pages/diver/assets/4rabet/4rabet-anim/Comp 2_00043.png';
import rocket_anim_44 from '@pages/diver/assets/4rabet/4rabet-anim/Comp 2_00044.png';
import rocket_anim_45 from '@pages/diver/assets/4rabet/4rabet-anim/Comp 2_00045.png';
import rocket_anim_46 from '@pages/diver/assets/4rabet/4rabet-anim/Comp 2_00046.png';
import rocket_anim_47 from '@pages/diver/assets/4rabet/4rabet-anim/Comp 2_00047.png';
import rocket_anim_48 from '@pages/diver/assets/4rabet/4rabet-anim/Comp 2_00048.png';
import rocket_anim_49 from '@pages/diver/assets/4rabet/4rabet-anim/Comp 2_00049.png';
import waitingSubmarineUrl from '@pages/diver/assets/4rabet/loader.gif';

export const GAME_CONFIG_4RABET = {
    skinId: 'diver-4rabet',
    logo: customLogoUrl,
    headerBg: 'unset',
    sidebarBg: 'unset',
    gameAreaBg: customBgUrl,
    submarineWidth: 350,
    submarineHeight: 270,
    submarineOffsetX: 150,
    submarineOffsetY: 140,
    submarine: [rocket_anim_0, rocket_anim_1, rocket_anim_2, rocket_anim_3, rocket_anim_4, rocket_anim_5, rocket_anim_6, rocket_anim_7, rocket_anim_8, rocket_anim_9, rocket_anim_10, rocket_anim_11, rocket_anim_12, rocket_anim_13, rocket_anim_14, rocket_anim_15, rocket_anim_16, rocket_anim_17, rocket_anim_18, rocket_anim_19, rocket_anim_20, rocket_anim_21, rocket_anim_22, rocket_anim_23, rocket_anim_24, rocket_anim_25, rocket_anim_26, rocket_anim_27, rocket_anim_28, rocket_anim_29, rocket_anim_30, rocket_anim_31, rocket_anim_32, rocket_anim_33, rocket_anim_34, rocket_anim_35, rocket_anim_36, rocket_anim_37, rocket_anim_38, rocket_anim_39, rocket_anim_40, rocket_anim_41, rocket_anim_42, rocket_anim_43, rocket_anim_44, rocket_anim_45, rocket_anim_46, rocket_anim_47, rocket_anim_48, rocket_anim_49],
    waitingSubmarine: waitingSubmarineUrl,
    historySubmarine: historySubmarineUrl,
    // colors: ['#a0a2a6', '#2d4cc9', '#111a2d', 'pink', 'yellow'],
    colors: ['#097BFD', '#FEB62A', '#E50439', '#0AA46C', '#2FE3D1'],
    font: `'Open Sans', sans-serif`,

    howToPlayVideo: {},

    // color
    primaryColor: '#202842',
    secondaryColor: '#121926',
    progressBarColor: '#3486E3',
    progressBarBgColor: '#161F38',
    makebetButtonBgColor: '#3486E3',
    cancelButtonBgColor: '#FF5350',
    cashoutButtonBgColor: '#EAA926',

    makebetButtonHoverBackground: '',
    makebetButtonHoverColor: '',
    makebetButtonHoverFilter: 'brightness(120%)',
    cashoutButtonHoverBackground: '',
    cashoutButtonHoverColor: '',
    cashoutButtonHoverFilter: 'brightness(120%)',
    cancelButtonHoverBackground: '',
    cancelButtonHoverColor: '',
    cancelButtonHoverFilter: 'brightness(120%)',

    chatRowBgColor: '#18243D',
    tableRowBgColor: '#18243D',
    secondaryButtonsBgColor: '#1E3463',
    secondaryPresetsButtonsBgColor: '#1E3463',


    // modal

    modalInputsBorder: '#161F38',
    modalInputBg: '#161F38',
    modalBgColor: '#1A284F',
    modalButtonBgColor: '#3486E3',


    // border
    primaryBorder: '#202842',
    secondaryBorder: '#202842',
    primaryBorderRadius: '12px',
    secondaryBorderRadius: '4px',
    headerBorderRadius: '8px',
    activeAvatarBorderColor: '#0098FF',

    // font
    secondaryFontColor: '#fff',
    betPresetsButtonsFontColor: '#fff',
    currencyIconFillColor: '#fff',
    makebetButtonFontColor: '#fff',
    modalButtonFontColor: '#fff',
    cancelButtonFontColor: '#fff',
    cashoutButtonFontColor: '#121926',
    changeAvatarTextColor: '#0098FF',
    hoverFontColor: '#3486E3',
    autoPlayModalButtonsTextTransform: 'uppercase',

    // coeffs
    less1point2coeffBg: '#FF3388',
    less1point5coeffBg: '#3990F4',
    less3coeffBg: '#6942D6',
    from3till10coeffBg: '#7B2591',
    from10till100coeffBg: '#4EC7C3',
    from100till1000coeffBg: '#1146CD',
    greater1000coeffBg: '#AE18C5',
    coeffBorderRadius: '8px',

    howToPlayButtonBackground: '#1E3463',

    previousButtonBackground: '#1E3463',
    previousButtonBorder: '',
    previousButtonBorderRadius : '8px',

    sidebarSelectorItemPadding: '12px 0',
    sidebarSelectorBorderRadius: '8px',
    sidebarSelectorMargin: '4px',

    // custom only 4rabet
    betInputBg: '#161F38',
    autoplayPresetsBg: '#1E3463',
    resetButtonBg: '#1E3463',
    chatModalBg: '#1A284F',
    chatInputBg: '#161F38',
    buttonsHoverBG: '#3486E3',
    previousButtonHoverFontColor: '#fff',
    sidebarSelectorBorder: 'none',
    menuBG: '#1A284F',
    coefficientsButtonBg: '#1E3463',
    cashOutSumFontSize: '12px',
    chatButtonColor: '#1E3463',

    waitingScreenSubmarineHeight: '56px',
    waitingScreenSubmarineFontSize: '16px',

    modalContainerContentBackground:'#1A284F',
    coefficientsBlockBackground: '#202842',
    previousHandHoverColor: '#fff'

};